import { CostComponent } from "@/types/project";

export function calculateAnticipatedFinal(component: CostComponent): number {
  if (!component) return 0;
  return (component?.toDate || 0) + (component?.forecast || 0);
}

export function calculateVariance(component: CostComponent): number {
  if (!component) return 0;
  const anticipatedFinal = calculateAnticipatedFinal(component);
  return (component?.budgeted || 0) - anticipatedFinal;
}

export function isOverBudget(variance: number): boolean {
  return variance < 0;
}